(ns frontend.ui.component.lp-portal.report.component.overview-figures.controller
  (:require
   [frontend.ui.component.dynamic-table.view :as dynamic-table]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :refer [format-data]]))


(defn figures
  [overview-figures]
  (->> overview-figures
       :data
       (take 6)
       (mapv (fn [row]
               (let [cell-style (some->> row
                                         :cell-styles
                                         (first)
                                         :data-format-string)
                     data-type (some->> row
                                        :cell-data-types
                                        (first))
                     value (some->> row
                                    :row-data
                                    (first))
                     comment (->> row
                                  :row-data
                                  (second))
                     label (:row-key row)
                     formatted-value (dynamic-table/formatted-cell-data value data-type cell-style)]
                 [label formatted-value comment])))))

(defn figures-v2
  [kpi-figures]
  (->> kpi-figures
       :rows
       (mapv (fn [{:keys [row-data row-comment _row-highlight row-type _row-font-style row-multipliers
                          row-data-types row-decimals format-row empty-indicator-row _row-style]}]
               (let [value (->> row-data
                                (second))
                     label (->> row-data
                                (first))
                     formatted-value (format-data row-data-types
                                                  row-decimals
                                                  row-multipliers
                                                  format-row
                                                  empty-indicator-row
                                                  row-type
                                                  value)]
                 [label formatted-value row-comment])))))
